/**
 * @typedef {'debug' | 'info' | 'warn' | 'error'} LogLevel
 */

/**
 * @typedef {Object} Logger
 * @property {(...args: unknown[]) => void} debug
 * @property {(...args: unknown[]) => void} info
 * @property {(...args: unknown[]) => void} warn
 * @property {(...args: unknown[]) => void} error
 */

const PRODUCTION = !location.hostname.includes('localhost') && location.protocol !== 'http:';

/**
 * Create a namespaced logger. In production, debug/info are silenced.
 * @param {string} namespace
 * @returns {Logger}
 */
export function createLogger(namespace) {
  const prefix = `[${namespace}]`;
  return {
    debug: (...args) => { if (!PRODUCTION) console.debug(prefix, ...args); },
    info:  (...args) => { if (!PRODUCTION) console.log(prefix, ...args); },
    warn:  (...args) => console.warn(prefix, ...args),
    error: (...args) => console.error(prefix, ...args),
  };
}
